module.exports = __webpack_public_path__ + "static/media/caracteristicas-banner.64f5987c.png";